module.exports = __webpack_public_path__ + "images/branding/lincoln_financial/login_button.gif";